import React from 'react';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { paths } from '@/app/paths';
import { FeatureFlagsListPage } from './FeatureFlagsListPage';
import { FeatureFlagDrawer } from './FeatureFlagDrawer';

export const featureFlagsRoutes = [
	{
		path: 'feature-flags',
		element: <FeatureFlagsListPage />,
		handle: { title: 'Feature flags', icon: <FlagOutlinedIcon /> },
		children: [{ path: ':flagId', element: <FeatureFlagDrawer /> }],
	},
];

export const featureFlagsNavItem = {
	text: 'Feature flags',
	icon: <FlagOutlinedIcon sx={{ fontSize: 30 }} />,
	link: `${paths.admin}/feature-flags`,
};
